import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Box
} from '@mui/material';
import AnalyticsPanel from './AnalyticsPanel';

const AdminAnalytics = () => {
  return (
    <Container maxWidth="xl">
      <Paper elevation={0} sx={{ mb: 3, p: 3, bgcolor: 'background.default' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Analytics Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Monitor user engagement, page analytics, and system performance metrics.
        </Typography>
      </Paper>

      <Box>
        <AnalyticsPanel hideTitle />
      </Box>
    </Container>
  );
};

export default AdminAnalytics; 